import { async } from 'q'
import sendEmail from 'sendmail'

// const name = 'Prithvi'
// const email = 'prithviashok@gmail.com'

export const createMailForReview = async(workRequest: any, questionId: string,name:string,email:string) => {
  const title = 'New Question For Review Assigned To You'
  const description = `You have recieved a new question (id: ${questionId}) for review in work request: ${workRequest?.name}`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  await sendEmail(mail_obj)
 
}

export const createMailForApproval = (workRequest: any, questionId: string,name:string,email:string) => {
  const title = `New Question For Approval Assinged To You`
  const description = `You have recieved a new question (id: ${questionId}) for approval in work request: ${workRequest?.name}`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
}

export const createMailOpenRequireAmending = (workRequest: any, questionId: string,name:string,email:string) => {
  const title = `Question Require Amending`
  const description = `Your question (id: ${questionId}) require some amending. Work request: ${workRequest?.name}`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
}

export const createMailForReviewRequireAmending = (workRequest: any, questionId: string,name:string,email:string) => {
  const title = `Reviewed Question Require Amending`
  const description = `Your reviewed question (id: ${questionId}) require some amending. Work request: ${workRequest?.name}`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
}

export const createMailRejectedAtRewiew = (workRequest: any, questionId: string,name:string,email:string) => {
  const title = `Question Rejected At Review`
  const description = `Your question (id: ${questionId}) has been rejected by reviewer in work request: ${workRequest?.name}`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
}

export const createMailRejectedAtApproval = (workRequest: any, questionId: string,name:string,email:string) => {
  const title = `Question Rejected At Approval`
  const descriptionOne = `Your question (id: ${questionId}) has been rejected by approval in work request: ${workRequest?.name}`
  const descriptionTwo = `Your reviewed question (id: ${questionId}) has been rejected by approval in work request: ${workRequest?.name}`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${descriptionOne}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
    {
      subject: title,
      to: [{ name: name, email: email }],
      htmlContent: `<html><body>Hai,<br/><h4> ${descriptionTwo}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
}
export const createMailWorkRequestCreator = (recName:string,recEmail:string,wrName:string,senderName:string,wrCount:any) => {
  const title = `Work Request Created and assigned to you`
  const description = `<html><body>Hai,<br/><h4> Work Request ${wrName} is created by ${senderName} and assigned to you. You have to create ${wrCount} questions.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: recName, email: recEmail }],
      htmlContent: description
    },
  ]
  sendEmail(mail_obj)
}
export const createMainVerify = (evaluation: any) => {
  const title = `Evaluation Verified and Forwarded`
  const description = `Evaluation Request  (id: #${evaluation?.evaluation_request?.request_id}-${evaluation?.evaluation_request?.name}}) has been verified and forwarded by Evaluation In Charge`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: evaluation?.evaluation_request?.createdBy?.displayName, email: evaluation?.evaluation_request?.createdBy?.email, }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
}
export const createMailForEvaluators = (evaluation: any,evaluators:any) => {
  const title = `Evaluation Verified and Forwarded`
  const description = `Evaluation Request  (id: #${evaluation?.evaluation_request?.request_id}-${evaluation?.evaluation_request?.name}}) has been verified and forwarded by Evaluation In Charge`
  const evaluator_user_array = evaluators?.filter((item: any) => evaluation?.evaluation_request?.evaluator_ids?.includes(item?.id))
  evaluator_user_array?.map((elem: any) => {
     let mail_obj = [
    {
      subject: title,
      to: [{ name: elem?.displayName, email: elem?.email, }],
      htmlContent: `<html><body>Hai,<br/><h4> ${description}.For more information, Login to <a>centa ams</a> .</h4></body></html>`,
    },
  ]
  sendEmail(mail_obj)
  })
 
  
}
export const createMailForSecondReviewer = (question_smart_id: any,recName:any,recEmail:any) => {
  const title = `Second Review Request`
  const description = `<html><body>Hai,<br/><h4> Question #${question_smart_id} is assigned to you for second review.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: recName, email: recEmail }],
      htmlContent: description
    },
  ]
  sendEmail(mail_obj)
 
  
}
export const createMailForSecondApprover = (question_smart_id: any,recName:any,recEmail:any) => {
  const title = `Second Approval Request`
  const description = `<html><body>Hai,<br/><h4> Question #${question_smart_id} is assigned to you for second approval.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: recName, email: recEmail }],
      htmlContent: description
    },
  ]
  sendEmail(mail_obj)
 
  
}
export const createMailForFirstReviewer = (question_smart_id: any,recName:any,recEmail:any) => {
  const title = `Second Review Completed`
  const description = `<html><body>Hai,<br/><h4> Question #${question_smart_id} is verification is completed.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: recName, email: recEmail }],
      htmlContent: description
    },
  ]
  sendEmail(mail_obj)
 
  
}
export const createMailForFirstApprover = (question_smart_id: any,recName:any,recEmail:any) => {
  const title = `Second Approval Completed`
  const description = `<html><body>Hai,<br/><h4> Question #${question_smart_id} is verification is completed.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`
  const mail_obj = [
    {
      subject: title,
      to: [{ name: recName, email: recEmail }],
      htmlContent: description
    },
  ]
  sendEmail(mail_obj)
 
  
}
